import { createContext, useContext, useEffect, useState } from "react";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const profile = JSON.parse(localStorage.getItem("profile"));
  const userKey = profile?._id || "guest";

  const [notifications, setNotifications] = useState(() => {
    const saved = localStorage.getItem(`notifications:${userKey}`);
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem(`notifications:${userKey}`, JSON.stringify(notifications));
  }, [notifications, userKey]);

  const addNotification = (notification) => {
    setNotifications((prev) => {
      const exists = prev.some((n) => n.id === notification.id);
      return exists ? prev : [...prev, notification];
    });
  };

  const removeNotification = (id) => {
    setNotifications((prev) => {
      const updated = prev.filter((n) => n.id !== id);
      localStorage.setItem("notifications", JSON.stringify(updated));
      return updated;
    });
  };

  const clearNotifications = () => {
    setNotifications([]);
    localStorage.setItem(`notifications:${userKey}`, JSON.stringify([]));
  };

  return (
    <NotificationContext.Provider
      key={userKey}
      value={{ notifications, addNotification, removeNotification, clearNotifications }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
